import SettingMyQrCode from "components/Profiles/SettingMyQrCode";
import NotFooterLayout from "layouts/NotFooterLayout";

const SettingmyQrCodePage = () => {
  return (
    <>
      <NotFooterLayout namePage="คิวอาร์โค้ดของฉัน">
        <div className="layout-content">
            <SettingMyQrCode />
        </div>
      </NotFooterLayout>
    </>
  );
};

export default SettingmyQrCodePage;
